import React from 'react';

import {
  makeStyles,
  createStyles,
  Theme,
  LinearProgress,
} from '@material-ui/core';
import {
  ExpandMore as ExpandMoreIcon,
  ChevronRight as ChevronRightIcon,
  FolderOpen as FolderIcon,
  Description as FileIcon,
} from '@material-ui/icons';
import { TreeView, TreeItem } from '@material-ui/lab';

import { IFolderNode } from '../../types/dataset';

interface Props {
  node: IFolderNode;
  onClick: (node: IFolderNode) => void;
}

const useItemStyles = makeStyles((theme: Theme) =>
  createStyles({
    labelRoot: {
      display: 'flex',
      alignItems: 'center',
    },
    labelIcon: {
      marginRight: theme.spacing(1),
    },
  })
);

const FolderItem = ({ node, onClick }: Props) => {
  const classes = useItemStyles();
  let childrenItems: JSX.Element[] = [];

  if (node.type === 'folder') {
    if (Array.isArray(node.children)) {
      const sortedChildren: IFolderNode[] = [
        ...node.children.filter((child) => child.type === 'folder'),
        ...node.children.filter((child) => child.type === 'file'),
      ];
      childrenItems = sortedChildren.map((child) => (
        <FolderItem key={child.id} node={child} onClick={onClick} />
      ));
    } else {
      childrenItems = [<LinearProgress />];
    }
  }

  return (
    <TreeItem
      nodeId={node.id}
      label={
        <div className={classes.labelRoot}>
          {node.type === 'folder' ? (
            <FolderIcon color="primary" className={classes.labelIcon} />
          ) : (
            <FileIcon color="secondary" className={classes.labelIcon} />
          )}
          {node.name}
        </div>
      }
      onClick={() => onClick(node)}
    >
      {childrenItems}
    </TreeItem>
  );
};

const FolderView = ({ node, onClick }: Props) => {
  return (
    <TreeView
      defaultCollapseIcon={<ExpandMoreIcon />}
      defaultExpandIcon={<ChevronRightIcon />}
      defaultExpanded={[node.id]}
    >
      <FolderItem node={node} onClick={onClick} />
    </TreeView>
  );
};

export default FolderView;
